export const common = {
  // Navbar
  'nav.overview': 'Akopọ',
  'nav.directory': 'Itọsọna Ijo',
  'nav.worship': 'Iṣẹ Ijosin',
  'nav.live': 'Ọjọ Isinmi Laaye',
  'nav.ministries': 'Awọn Iṣẹ Ìránṣẹ́',
  'nav.leadership': 'Aṣáájú',
  'nav.adminLogin': 'Wọle Alábòójútó',
  'nav.language': 'Èdè',
  
  // Language names
  'lang.english': 'Gẹẹsi',
  'lang.yoruba': 'Yorùbá',
  'lang.hausa': 'Hausa',
  'lang.igbo': 'Igbo',
  'lang.pidgin': 'Pidgin',
  
  // Hero Section
  'hero.badge': 'Eto Ijosin Dijitali ti Orilẹ-ede',
  'hero.title': 'Fifun Gbogbo Ijo Seventh-day Adventist ni Nigeria ni Agbara',
  'hero.description': 'Ẹrọ dijitali ti o ṣọkan ti o sopọ gbogbo awọn ijo SDA kọja Nigeria. Wọle si awọn iṣẹ ijosin laaye, wa awọn ijo nitosi rẹ, ṣakoso awọn iṣẹlẹ, ati mu agbegbe wa lagbara nipasẹ imọ-ẹrọ.',
  'hero.exploreChurches': 'Ṣawari Awọn Ijo',
  'hero.worshipTools': 'Awọn Irinṣẹ Ijosin',
  'hero.liveNow': 'Laaye Bayi',
  'hero.scrollExplore': 'Yiyi lati ṣawari',
  
  // Stats
  'stats.churches': 'Awọn Ijo',
  'stats.members': 'Awọn Ọmọ Ẹgbẹ Tí Ń Ṣiṣẹ́',
  'stats.liveServices': 'Awọn Iṣẹ Laaye Lọsẹ',
  'stats.events': 'Awọn Iṣẹlẹ Oṣooṣu',
  
  // Features
  'features.watchLive': 'Wo Laaye',
  'features.watchLiveDesc': 'Darapọ mọ awọn iṣẹ ijosin laaye lati awọn ijo kọja Nigeria',
  'features.findChurch': 'Wa Ijo',
  'features.findChurchDesc': 'Wa awọn ijo SDA ni agbegbe rẹ pẹlu alaye kikun',
  'features.events': 'Awọn Iṣẹlẹ',
  'features.eventsDesc': 'Jẹ ki o ni imudojuiwọn pẹlu awọn apejọ, awọn eto, ati awọn iṣẹ',
  'features.ministriesTitle': 'Awọn Iṣẹ Ìránṣẹ́',
  'features.ministriesDesc': 'Sopọ pẹlu ọpọlọpọ awọn ẹka iṣẹ-ìránṣẹ́ ati awọn eto',
  
  // CTA
  'cta.title': 'Ṣetan lati Sopọ Ijo Rẹ?',
  'cta.description': 'Darapọ mọ nẹtiwọọki orilẹ-ede ki o mu ijọ rẹ wọ inu ọjọ ori dijitali. Wọle si awọn irinṣẹ ti o lagbara fun ijosin, ibaraẹnisọrọ, ati kikọ agbegbe.',
  'cta.getStarted': 'Bẹrẹ Loni',
  'cta.learnMore': 'Kọ Ẹkọ Diẹ Sii',
  
  // Footer
  'footer.tagline': 'Sisopọ awọn ijo Seventh-day Adventist kọja Nigeria nipasẹ awọn ojutu dijitali ti o ṣe afihan.',
  'footer.quickLinks': 'Awọn Ọna Asopọ Kiakia',
  'footer.resources': 'Awọn Ohun Elo',
  'footer.contact': 'Olubasọrọ',
  'footer.home': 'Ile',
  'footer.about': 'Nipa Wa',
  'footer.churches': 'Awọn Ijo',
  'footer.liveStream': 'Ṣiṣan Laaye',
  'footer.worshipGuide': 'Itọsọna Ijosin',
  'footer.techSupport': 'Atilẹyin Imọ-ẹrọ',
  'footer.training': 'Ikẹkọ',
  'footer.documentation': 'Iwe-akọsilẹ',
  'footer.email': 'Imeeli',
  'footer.phone': 'Foonu',
  'footer.address': 'Adirẹsi',
  'footer.rights': 'Gbogbo awọn ẹtọ ni ipamọ.',
  'footer.privacy': 'Ilana Aṣiri',
  'footer.terms': 'Awọn Ofin Iṣẹ',
  
  // Directory Page
  'directory.title': 'Itọsọna Ijo',
  'directory.subtitle': 'Wa awọn ijo Seventh-day Adventist kọja Nigeria',
  'directory.search': 'Wa awọn ijo...',
  'directory.allRegions': 'Gbogbo Awọn Agbegbe',
  'directory.allStates': 'Gbogbo Awọn Ipinlẹ',
  'directory.viewDetails': 'Wo Awọn Alaye',
  'directory.getDirections': 'Gba Awọn Itọsọna',
  'directory.members': 'awọn ọmọ ẹgbẹ',
  
  // Live Page
  'live.title': 'Awọn Iṣẹ Ijosin Laaye',
  'live.subtitle': 'Darapọ mọ awọn iṣẹ Ọjọ Isinmi laaye lati awọn ijo kọja Nigeria',
  'live.allRegions': 'Gbogbo Awọn Agbegbe',
  'live.watchNow': 'Wo Bayi',
  'live.viewers': 'awọn oluwo',
  'live.starting': 'Bẹrẹ',
  
  // Events Page
  'events.title': 'Awọn Iṣẹlẹ Ti Nbọ',
  'events.subtitle': 'Ṣawari awọn apejọ, awọn idanileko, ati awọn eto kọja Nigeria',
  'events.allCategories': 'Gbogbo Awọn Ẹka',
  'events.register': 'Forukọsilẹ Bayi',
  'events.learnMore': 'Kọ Ẹkọ Diẹ Sii',
  'events.attendees': 'awọn olukopa',
  
  // Ministries Page
  'ministries.title': 'Awọn Ẹka Iṣẹ-Ìránṣẹ́',
  'ministries.subtitle': 'Ṣawari awọn eto iṣẹ-ìránṣẹ́ ati awọn ẹka wa',
  'ministries.learnMore': 'Kọ Ẹkọ Diẹ Sii',
  'ministries.programs': 'awọn eto',
  
  // Tools Page
  'tools.title': 'Awọn Irinṣẹ Ijosin',
  'tools.subtitle': 'Awọn ojutu dijitali fun iṣakoso ijo ode oni',
  'tools.getStarted': 'Bẹrẹ',
  'tools.learnMore': 'Kọ Ẹkọ Diẹ Sii',
};

export default {
  // ... existing code ...
  
  // New translations for enhanced landing page
  whatYouCanDo: 'Ohun Ti O Le Ṣe',
  platformDescription: 'Ṣawari gbogbo awọn ọna ti pẹpẹ wa ṣe iranlọwọ fun ọ lati wa ni asopọ pẹlu awujọ ijo rẹ ati dagba ninu igbagbọ',
  learnMore: 'Kọ Ẹkọ Diẹ Sii',
  
  howItWorks: 'Bawo Ni O Ṣe N Ṣiṣẹ',
  howItWorksDesc: 'Bibẹrẹ rọrun. Tẹle awọn igbesẹ mẹrin rọrun wọnyi lati bẹrẹ irin-ajo rẹ',
  
  discoverChurches: 'Ṣawari Awọn Ijo',
  discoverChurchesDesc: 'Wa atokọ pipe ti awọn ijo Seventh-day Adventist kọja Naijiria. Wa awọn ipo, awọn akoko isin, ati alaye olubasọrọ',
  
  joinWorship: 'Darapọ Mọ Isin Laaye',
  joinWorshipDesc: 'Wo awọn isin ti a ṣe laaye lati awọn ijo jakejado orilẹ-ede. Ni iriri isin lati ibikibi, nigbakugba',
  
  participateEvents: 'Kopa Ninu Awọn Iṣẹlẹ',
  participateEventsDesc: 'Jẹ ki o mọ nipa awọn apejọ, awọn idanileko, ati awọn eto agbegbe. Forukọsilẹ ki o si kopa ninu awọn iṣẹlẹ ti nbọ',
  
  connectCommunity: 'Sopọ Pẹlu Awujọ',
  connectCommunityDesc: 'Ṣe ajọṣepọ pẹlu awọn iṣẹ-ṣiṣe, darapọ mọ awọn ẹgbẹ kekere, ki o si kọ awọn ibatan pataki pẹlu awọn onigbagbọ ẹlẹgbẹ',
  
  whyChooseUs: 'Kilode Ti O Fi Yan Pẹpẹ Wa',
  whyChooseUsDesc: 'Ti a kọ ni pataki fun awujọ Seventh-day Adventist ni Naijiria pẹlu awọn ẹya ti o ṣe pataki julọ',
  
  accessAnywhere: 'Wọle Nibikibi',
  accessAnywhereDesc: 'Sopọ pẹlu awujọ ijo rẹ lati eyikeyi ẹrọ, boya o wa ni ile tabi ni irin-ajo',
  
  secureReliable: 'Aabo & Igbẹkẹle',
  secureReliableDesc: 'Data rẹ wa ni aabo pẹlu aabo ipele ile-iṣẹ. Gbadun iṣẹ ailopin ti o le gbẹkẹle',
  
  mobileOptimized: 'Foonu Alagbeka Ti O Dara Julọ',
  mobileOptimizedDesc: 'Apẹrẹ idahun ni kikun rii daju iriri ailopin lori awọn fonutologbolori, awọn tabulẹti, ati awọn desktops',
  
  communityFocused: 'Idojukọ Awujọ',
  communityFocusedDesc: 'Ti a kọ pẹlu igbewọle lati ọdọ awọn oludari ijo ati awọn ọmọ ẹgbẹ lati sin awọn aini alailẹgbẹ ti awujọ wa',
  
  stayUpdated: 'Jẹ Ki O Wa Ni Imudojuiwọn',
  stayUpdatedDesc: 'Gba awọn iwifunni nipa awọn iṣẹlẹ pataki, awọn iwasu tuntun, ati awọn ikede awujọ',
  
  comprehensiveTools: 'Awọn Irinṣẹ Pipe',
  comprehensiveToolsDesc: 'Wọle si eto pipe ti awọn irinṣẹ oni-nọmba ti a ṣe apẹrẹ lati mu iṣakoso ijo ati ifaramọ ọmọ ẹgbẹ pọ si'
};
